// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"a3ce484a","423":"47ae096b","651":"57455c88","748":"8dfd1346"}[chunkId] + ".chunk.js";
};